import { DataExportType } from "@/api-schema-enums";
import { useAppFeatureFlag } from "@/common/hooks/use-app-feature-flag";
import { CommandButton } from "@/components/command-palette/command-button";
import { ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { FeatureFlag } from "@/config/feature-flags";
import { DownloadIcon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DataExportDialog } from "./data-export-dialog";

export interface DataExportButtonProps {
  type: DataExportType;
  query: object;
  body: unknown;
  defaultColumns: string[];
}

export function DataExportButton(props: DataExportButtonProps) {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);
  const { value: isCsvExportEnabled } = useAppFeatureFlag(FeatureFlag.CsvExport);

  if (!isCsvExportEnabled) {
    return null;
  }

  return (
    <>
      <CommandButton
        commandId={`data-export-${props.type}`}
        label={t("common:Export")}
        icon={<DownloadIcon className="h-4 w-4" />}
        variant={ButtonVariant.Outlined}
        colorVariant={ButtonColorVariant.Secondary}
        onClick={() => setOpen(true)}
      />
      {open && <DataExportDialog {...props} open={open} onOpenChange={setOpen} />}
    </>
  );
}
